import { useStore } from 'vuex';
import emitter from '@/emitter';
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { actions, mutations } from '../store/types';
import { MODULE_NAME, EMITTER_KEY, PLAN_NAMES } from '../constants';
import { usePlanPermission, FEATURE_TYPES } from '@modules/common';
export const useEditorElements = () => {
  const store = useStore();
  const { getPermissionForTypeInfo } = usePlanPermission();
  const isRunningAbTest = computed(() => {
    if (!store.state.app.pageInfo?.runningCampaignId) return false;
    return store.state.app.pageInfo?.runningCampaignId > 0;
  });

  const shopInfo = computed(() => store.state.app?.shopInfo);
  const planName = computed(() => {
    //@ts-ignore
    return PLAN_NAMES[shopInfo?.value?.plan || ''] || '';
  });

  const isOpenSetting = computed(() => {
    return store.state.sidebar?.isOpenSetting;
  });

  const elementKeySettingActive = computed(() => {
    return store.state.sidebar?.elementKeySettingActive;
  });

  const isOverlayElementSetting = computed(() => {
    const popupPermission = getPermissionForTypeInfo(FEATURE_TYPES.POPUP_ELEMENT);
    return isOpenSetting.value && elementKeySettingActive.value === 'popup' && !popupPermission;
  });

  const sidePanelsWrapperClass = computed(() => {
    return isRunningAbTest.value ? 'overflow-hidden' : '';
  });

  const sidePanelClass = computed(() => {
    return isRunningAbTest.value ? 'ab-test__blur' : '';
  });

  const isLoadingSnippet = computed(() => {
    return store.state.sidebar.isLoadingSnippet;
  });

  const snippetCategories = computed(() => {
    return store.state.sidebar.snippetCategories;
  });

  const getSnippets = () => {
    store.dispatch(`${MODULE_NAME}/${actions.FETCH_SNIPPETS}`);
  };

  getSnippets();

  watch(isOverlayElementSetting, (newValue) => {
    const leftSidebar = jQuery('#gfLeftSideBar');
    const settingPanel = leftSidebar.find('.settings-panel');
    const designPanel = leftSidebar.find('.design-panel');
    if (newValue) {
      settingPanel.addClass('disable-active');
      designPanel.addClass('disable-active');
    } else {
      settingPanel.removeClass('disable-active');
      designPanel.removeClass('disable-active');
    }
  });

  onMounted(() => {
    const leftSidebar = jQuery('#gfLeftSideBar');
    //@ts-ignore
    leftSidebar.gfLeftSideBar();

    // listener add snippet
    emitter.on(EMITTER_KEY.ADD_NEW_SNIPPET, (snippet: any) => {
      store.commit(`${MODULE_NAME}/${mutations.ADD_NEW_SNIPPETS}`, snippet);
      store.commit('editor/SET_DATA_SNIPPETS', {
        key: snippet.key,
        value: snippet.html,
      });
      leftSidebar.data('gfleftsidebar').scrollIntoElement(`.snippet-wrap .snippet.isNew[data-key=${snippet.key}]`);
    });

    emitter.on(EMITTER_KEY.REMOVE_SNIPPET, (snippetId) => {
      store.commit(`${MODULE_NAME}/${mutations.DELETE_SNIPPET}`, snippetId);
    });
  });

  onBeforeUnmount(() => {
    emitter.off(EMITTER_KEY.ADD_NEW_SNIPPET);
    emitter.off(EMITTER_KEY.REMOVE_SNIPPET);
  });

  return {
    isRunningAbTest,
    sidePanelsWrapperClass,
    sidePanelClass,
    isLoadingSnippet,
    snippetCategories,
    isOpenSetting,
    isOverlayElementSetting,
    planName,
  };
};
